export const Routes = {
    root: "/",
    adminSetup: "/adminSetup",
    languageSelection: "/languageSelection",
    acquireHealthCardNumber: "/acquireHealthCardNumber",
    appointmentConfirmation: "/appointmentConfirmation",
    patientOverview: "/patientOverview",
    introduction: "/introduction",
    satisfactorySurvey: "/satisfactorySurvey"
}



// WEBPACK FOOTER //
// ./src/constants/routes.ts